import { dialogs, integration, saving, readOnly } from '@yola/ws-sdk';
import store from 'src/js/store';
import dialogTypes from 'src/js/modules/dialogs/constants/dialog-types';
import checkForPendingMigrations from './check-for-pending-migrations';

const { ERROR, SAVING } = saving.constants.statuses;

const saveSiteWithEffect = async (fn = () => {}) => {
  const state = store.getState();
  const readOnlyStatus = readOnly.selectors.getReadOnlyStatus(state);
  if (readOnlyStatus) {
    await fn();
    return null;
  }
  let savingStatus = saving.selectors.getStatus(state);

  if (savingStatus === SAVING) {
    return null;
  }

  const saveResponse = await store.dispatch(saving.thunks.save());
  savingStatus = saving.selectors.getStatus(state);

  if (savingStatus === ERROR) {
    return null;
  }

  const hasPendingMigration = checkForPendingMigrations(saveResponse);

  if (!hasPendingMigration) {
    await fn();

    return null;
  }

  const integrationSettings = integration.accessors.getSettings();

  const onAction = () => {
    integrationSettings.onReloadEditor();
  };

  store.dispatch(
    dialogs.actions.show(dialogTypes.UPDATE_REQUIRED, {
      onAction,
    })
  );

  return null;
};

const saveSite = () => {
  saveSiteWithEffect(Function.prototype);
};

export { saveSiteWithEffect };
export default saveSite;
